
import { API } from "../config/api";

class CalendarService {

    // Consult if the current time is within work hours/days ====================================================================================================

    /**
     * Consult if the current time is within work hours/days
     * @returns {object} - True or false if the current time is within work hours/days
    */
    consultaDiasFeriados() {
        const url = `/consultaDiasFeriados`;

        return API.post(url);
    }

}

export default new CalendarService();